import { render, staticRenderFns } from "./PaSection.vue?vue&type=template&id=e840b0ee"
import script from "./PaSection.vue?vue&type=script&lang=js"
export * from "./PaSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports